import { render, staticRenderFns } from "./media-clipper.vue?vue&type=template&id=4a8fa92a"
import script from "./media-clipper.vue?vue&type=script&lang=js"
export * from "./media-clipper.vue?vue&type=script&lang=js"
import style0 from "./media-clipper.vue?vue&type=style&index=0&id=4a8fa92a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports